/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SpaProductSummaryTypeDTO = {
    SIMPLE: 'SIMPLE',
    COMBO: 'COMBO'
} as const;
export type SpaProductSummaryTypeDTO = typeof SpaProductSummaryTypeDTO[keyof typeof SpaProductSummaryTypeDTO];

